// extracted by mini-css-extract-plugin
export default {"exclusion":"Exclusion_exclusion__qUAId","exclusion__content":"Exclusion_exclusion__content__D2vHz"};